/* The three-step flow indicator. Ported verbatim from artifact.html: the same markup is
   written into all three mount points, and the step numbers become ticks once done. */

const STEPS = [["Sign in", 1], ["Create a project", 2], ["Upload & run", 3]];

export function renderStepper(active) {
  const html = STEPS.map(([label, i], n) => {
    const cls = i < active ? "done" : i === active ? "on" : "";
    const mark = i < active ? "✓" : String(i);
    return `<div class="fstep ${cls}"><span class="fn">${mark}</span><span class="fl2">${label}</span></div>` +
      (n < STEPS.length - 1 ? '<div class="fconn"></div>' : "");
  }).join("");
  for (const id of ["fs-auth", "fs-home", "fs-proj"]) {
    const el = document.getElementById(id);
    if (el) el.innerHTML = html;
  }
}
